window.addEventListener("load", function () {
    // Initialize Swiper for mobile only
    if (window.innerWidth <= 768) {
        const privilegeSwiper = new Swiper(".list_privilege", {
            slidesPerView: 1.6,
            centeredSlides: true,
            loop: true,
            spaceBetween: 10,
            slideToClickedSlide: true,
        });
    }
});
